<template>
  <div class="content" v-if="!loading">
    <div class="noCommodity" v-if="qrcodePath == ''">
      <div class="van-empty">
        <div class="van-empty__image">
          <img src="@assets/images/empty-image-default.png" />
        </div>
        <p class="van-empty__description">暂无信息</p>
      </div>
    </div>
    <div class="qrcode-content" else>
      <img :src="qrcodePath" />
    </div>
  </div>
</template>

<script>
import { getWechatQrcode } from "@api/public";
export default {
  name: "WechatQrcode",
  props: {},
  data: function() {
    return {
      qrcodePath: "",
      loading: true
    };
  },
  mounted() {
    this.initWechat();
  },
  methods: {
    initWechat: function() {
      let obj = this;
      getWechatQrcode().then(res => {
        obj.qrcodePath = res.data.path;
        obj.loading = false;
      });
    }
  }
};
</script>
<style scoped>
.qrcode-content {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100vh;
  background-color: black;
}
.qrcode-content img {
  width: 5rem;
  height: 5rem;
}
.van-empty {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0.5rem 0;
}
.van-empty__image {
  height: 4rem;
  width: 4rem;
}
.van-empty__image img {
  width: 100%;
  height: 100%;
}
.van-empty__description {
  width: 100%;
  text-align: center;
  margin-top: 0.2rem;
  color: #9e9e9e;
  font-size: 0.3rem;
}
.loadend {
  line-height: 1rem;
  text-align: center;
  color: #bbb;
  font-size: 0.3rem;
}
</style>
